import React from 'react';
import Header from './components/Header/Header';
import TeamSection from './components/TeamSection/TeamSection';

function App() {
  return (
    <div>
      <Header></Header>
      <TeamSection></TeamSection>
    </div>
  );
}

export default App;
